import { numberFormatter } from '~library/numbers';

// Local copy of dashboard-v3's `percentageFormatter` with one difference:
// exact-zero values render as `"0%"` instead of `"< 0.1%"`. The shared
// formatter is used across six dashboard-v3 chart surfaces, so we keep this
// behavior scoped to the Discoverability charts to avoid rippling the change.
export function formatDiscoverabilityPercentage(percentage: number): string {
  if (percentage === 0) return '0%';

  const absValue = Math.abs(percentage);

  if (absValue <= 0.09) return '< 0.1%';
  return `${numberFormatter.format(absValue)}%`;
}
